import {
    Button,
    ContentSectionContainer,
    DialogHandler,
    FullBar,
    GenericWrapperContext,
    Header,
    Icon,
    SystemEmailsFactory,
    SystemEmailsModel
} from "@cakemail-org/ui-components-v2"
import { useContext, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import SystemEmailsTable from "./components/tableListing"
import { SystemEmailsContainerContext } from "./context"
import { showSystemEmailDialog } from "./components/edit"
import { ESystemEmailType } from "./components/tableListing/types"

export default function SystemEmails() {
    const genericWrapper = useContext(GenericWrapperContext)
    const account = genericWrapper.account
    const { t, i18n } = useTranslation()

    const [loading, setLoading] = useState<boolean>(true)
    const [systemEmails, setSystemEmails] = useState<SystemEmailsModel>()

    //This is just to keep a reference to what the child component chose
    const currentTab = useRef(ESystemEmailType.accountConfirm)

    useEffect(fetchSystemEmails, [])

    function handleAddSystemEmail() {

        if (account)
            showSystemEmailDialog({
                initSysEmailName: account.isPartnerOrOrganization() ? currentTab.current : ESystemEmailType.contactDOptIn,
                account: account,
                action: "create",
                partnerBrand: genericWrapper.partnerBrand,
                onSuccess: fetchSystemEmails,
                initSystemEmails: systemEmails,
                onError: ({ msg, data, code }) => {
                    DialogHandler.show({
                        title: t(msg || "error-system-emails-create"),
                        type: "error"
                    })
                }
            })
    }

    function fetchSystemEmails() {
        setLoading(true)

        SystemEmailsFactory.list()
            .then((sysEmails) => {
                setSystemEmails(sysEmails)
                setLoading(false)
            })
            .catch(({ msg }) => {
                DialogHandler.show({
                    title: t(msg || "error-system-emails-fetch"),
                    type: "error"
                })
                setLoading(false)
            })
    }

    return <ContentSectionContainer className="manageSystemEmails">
        <SystemEmailsContainerContext.Provider value={{
            systemEmails: systemEmails,
            currentTab
        }}>
            <FullBar
                left={
                    <Header
                        support={t("system-emails-listing-subtitle")}
                        heading={t("general-system-emails")}
                        headingVariant="h3L"
                        headingTooltip={t("system-emails-listing-title-tooltip")}
                    />
                }
                right={<>
                    <Button iconOnly color="secondary" onClick={handleAddSystemEmail}><Icon name="Add18" /></Button>
                </>}
            />

            <SystemEmailsTable
                loading={loading}
                reloadTable={fetchSystemEmails}
            />
        </SystemEmailsContainerContext.Provider>
    </ContentSectionContainer>
}